



























import {
  defineComponent, reactive, ref,
} from '@vue/composition-api';

import {
  storeUpdateSubJobAmount,
} from '@/api';

import pendingReceiveSubJob from '@/table/Store/pending-receive-sub-job';

const CommonModalWithStoreReceiveStatus = defineComponent({
  props: {
    column: { default: '' },
  },
  setup(props, { emit }) {
    const modal = ref(null);
    const toCurrencyWithoutSign = (amount: number): string => (amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    function compose(payload: any) {
      form.items = payload.items.map((item: any) => ({
        ...item,
        [props.column]: 0,
        availableAmount: item[props.column === 'receive_amount' ? 'qc_store_amount' : 'store_amount'] + (props.column !== 'receive_amount' ? item.assembly_pending_amount : 0),
      }));
      (modal.value as any).open();
    }

    const form = reactive({
      items: [],
      call: async () => {
        await storeUpdateSubJobAmount({
          items: form.items.map((item: any) => ({
            id: item.id,
            [props.column]: item[props.column],
          })),
        });
        emit('done');
        (modal.value as any).close();
      },
    });

    return {
      toCurrencyWithoutSign,
      pendingReceiveSubJob,
      form,
      modal,
      compose,
    };
  },
});

export default CommonModalWithStoreReceiveStatus;
